/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
<template>
<div>
</div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'LoginCallback',
  data() {
    return {
      NotActiveUser:'false',
    };
  },
  async beforeMount () {
    console.log("LoginCallback");
    // var exists = authClient.tx.exists();
    //   if (exists) {
    //     console.log('a session exists');
    //   } else {
    //     console.log('a session does not exist');
    //   }
    await this.$auth.handleLoginRedirect()
    .catch((err) => 
    {
    //console.log("LoginCallBack.Error:", err);
    // this.$router.push({ name: 'LoggedOut', params: { NotActiveUser: 'true' } });
    this.$router.push({ name: 'LoggedOut' });
    });
  },
  
  render() { 
    // typescript not allow empty render function, here's the workaround for renderless component
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.$scopedSlots.default && this.$scopedSlots.default({});
  },
}
</script>



// WEBPACK FOOTER //
// src/components/LoginCallback.vue?222f25fc